// @flow

import React from 'react';
import type { Image } from '../../../types';
import { widthInUrl } from '../../../../../helpers';

export default ({
  url,
  name,
}: Image) => (
  <img
    src={widthInUrl(url, 110)}
    alt={name}
  />
);
